import 'normalize.css';
import './src/styles/main.scss';

import './src/components/main';